/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FeedbackQuestionsQueryVariables = Types.Exact<{
  orderId: Types.Scalars['ID'];
}>;

export type FeedbackQuestionsQuery = {
  readonly __typename?: 'Query';
  readonly feedbackQuestions: ReadonlyArray<{
    readonly __typename?: 'FeedbackQuestion';
    readonly id: string;
    readonly text: string | null;
    readonly slug: string | null;
    readonly responses: ReadonlyArray<{
      readonly __typename?: 'FeedbackResponse';
      readonly id: string;
      readonly text: string;
    }> | null;
  }>;
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder' }
    | {
        readonly __typename: 'OrderStatus';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
            };
          }>;
        };
      }
    | null;
};

export type SubmitFeedbackMutationVariables = Types.Exact<{
  input: Types.FeedbackInput;
}>;

export type SubmitFeedbackMutation = {
  readonly __typename?: 'Mutation';
  readonly submitFeedback: {
    readonly __typename?: 'FeedbackSuccess';
    readonly success: boolean;
  };
};

export const feedbackQuestionsQueryMock: ExecutionResult<FeedbackQuestionsQuery> =
  {
    data: {
      feedbackQuestions: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          text: 'Hello World',
          slug: 'Hello World',
          responses: [
            { id: 'a7a7163b-a7ed-4a96-a8a1-85e3da00a9a4', text: 'Hello World' },
            { id: '7534319d-0806-40b5-9aa2-50f9c4016b1b', text: 'Hello World' },
            { id: 'd634cb27-3b7f-49f1-8d03-0f1b1f2c49f5', text: 'Hello World' },
          ],
        },
        {
          id: 'fd7994cc-dcab-438b-b485-afbe88532ede',
          text: 'Hello World',
          slug: 'Hello World',
          responses: [
            { id: 'a1daa933-e0e0-495a-bb48-f0bb560d0180', text: 'Hello World' },
            { id: 'd39ca0c0-520a-4352-a4a6-541b5bc5d089', text: 'Hello World' },
          ],
        },
        {
          id: 'f52e921d-91bf-4dfb-abd3-8fdf8eb15058',
          text: 'Hello World',
          slug: 'Hello World',
          responses: [
            { id: 'b384c482-99be-4511-b9b1-e39b6d74afbe', text: 'Hello World' },
            { id: '52f8a3a6-f32f-40ed-aef1-22810af29152', text: 'Hello World' },
          ],
        },
      ],
      orderStatus: { __typename: 'InvalidOrder' },
    },
  };

export const submitFeedbackMutationMock: ExecutionResult<SubmitFeedbackMutation> =
  { data: { submitFeedback: { success: false } } };

export const FeedbackQuestionsDocument = gql`
  query feedbackQuestions($orderId: ID!) {
    feedbackQuestions(orderId: $orderId) {
      id
      text
      slug
      responses {
        id
        text
      }
    }
    orderStatus(orderId: $orderId) {
      __typename
      ... on OrderStatus {
        order {
          id
          orderType
          wantedTime
          description
          restaurant {
            id
            slug
            name
          }
          lineItems {
            id
            quantity
            customName
            product {
              id
              name
              slug
            }
          }
        }
      }
    }
  }
`;

export function useFeedbackQuestionsQuery(
  options: Omit<Urql.UseQueryArgs<FeedbackQuestionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>(
    { query: FeedbackQuestionsDocument, ...options },
  );
}
export const SubmitFeedbackDocument = gql`
  mutation submitFeedback($input: FeedbackInput!) {
    submitFeedback(input: $input) {
      success
    }
  }
`;

export function useSubmitFeedbackMutation() {
  return Urql.useMutation<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >(SubmitFeedbackDocument);
}
